import { call, put } from 'redux-saga/effects';

import { authBreadcrumb, captureAuthError, setAuthUserContext } from '@features/sentry-connect';
import { DocSnap, FirestoreUserData } from '@shared/types';

import { actions } from '../model/reducer';

import { getUserData } from '@shared/api/firestore';

export function* updateUser(snap: DocSnap) {
  const user = snap.data() as FirestoreUserData;
  yield put(actions.setFirestoreUserData(user));
}

export function* setFirestoreUserData() {
  const user: FirestoreUserData = yield call(getUserData);
  if (!user) {
    captureAuthError(new Error('getUserData returned undefined'), 'setFirestoreUserData:undefined-user');
    throw new Error('Firestore user data is undefined');
  }
  setAuthUserContext({ uid: user.userId, email: user.email, hasFirestoreDoc: true });
  authBreadcrumb('setFirestoreUserData: dispatching to store', {
    userId: user.userId,
    category: user.category ?? null,
  });
  yield put(actions.setFirestoreUserData(user));
}
